import { z } from 'zod/v4';
import { AttributeSchemaDTO } from '../attribute/types';
import { AttributeValuesDTO } from '../attribute/attribute-instance';
import { LinkDTO } from '@/entities/srm/link/@x/ci';

export const CILinkBriefDTO = z.object({
  ci_type_link_id: z.uuid(),
  link_name: z.string(),
  attributes: z.array(
    z.object({
      name: z.string(),
      value_schema: AttributeSchemaDTO,
    }),
  ),
});
export type CILinkBrief = z.infer<typeof CILinkBriefDTO>;

export const CILinkDTO = z.object({
  id: z.uuid(),
  src_ci_id: z.uuid(),
  dst_ci_id: z.uuid(),
  link: LinkDTO,
  ci_type_link_id: z.uuid(),
  // plane_link_status: z.boolean(),
  // plane_attribute_status: z.boolean(),
  attribute_values: AttributeValuesDTO,
});
export type CILink = z.infer<typeof CILinkDTO>;

export const CreateCILinkDTO = z.object({
  ci_type_link_id: z.uuid(),
  src_ci_id: z.uuid(),
  dst_ci_id: z.uuid(),
  attribute_values: AttributeValuesDTO,
});
export type CreateCILink = z.infer<typeof CreateCILinkDTO>;

export const UpdateCILinkDTO = CreateCILinkDTO.pick({
  attribute_values: true,
});
export type UpdateCILink = z.infer<typeof UpdateCILinkDTO>;

// export const CreateLinkDTO = z.object({
//   src_ci_id: z.uuid(),
//   dst_ci_id: z.uuid(),
//   link_id: z.uuid(),
// });
// export type CreateLink = z.infer<typeof CreateLinkDTO>;

// export const LinkValueSchemaDTO = z.object({
//   id: z.uuid(),
//   src_ci: CIBriefSchemaDTO,
//   dst_ci: CIBriefSchemaDTO,
//   link: LinkResponseDTO,
//   plane_link_status: z.boolean(),
//   plane_attribute_status: z.boolean(),
// });
// export type LinkValueSchema = z.infer<typeof LinkValueSchemaDTO>;

// export const LinkInfoSchemaDTO = z.object({
//   hi_link_id: z.uuid(),
//   hi_type_id: z.uuid(),
//   ci_type_id: z.uuid(),
//   hi_type_name: z.string(),
//   ci_type_name: z.string(),
//   incoming: z.boolean(),
// });
// export type LinkInfoSchema = z.infer<typeof LinkInfoSchemaDTO>;